import { render, staticRenderFns } from "./HelloAdmin.vue?vue&type=template&id=0afeda8b&scoped=true"
import script from "./HelloAdmin.vue?vue&type=script&lang=js"
export * from "./HelloAdmin.vue?vue&type=script&lang=js"
import style0 from "./HelloAdmin.vue?vue&type=style&index=0&id=0afeda8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afeda8b",
  null
  
)

export default component.exports